@use '../../../sass/theme';
@use '../../../sass/form-control-mixins';


:host {
  display: block;

  .jui-control {
    @include form-control-mixins.jui-control-base;

    > * {
      flex: 1 100%;
    }

    &__label {
      @include form-control-mixins.form-control-label;

      &--narrower {
        @include form-control-mixins.form-control-label-narrower;
      }
      &--disabled {
        @include form-control-mixins.form-label-disabled;
      }
    }

    &__label-text {
      @include form-control-mixins.form-control-label-text;
    }

    &__tooltip {
      @include form-control-mixins.form-control-tooltip;

      &--input-sm {
        @include form-control-mixins.form-control-tooltip-input-sm;
      }

      &--input-lg {
        @include form-control-mixins.form-control-tooltip-input-lg;
      }
    }

    &__help {
      @include form-control-mixins.form-control-help;
    }

    &__tooltip-text {
      @include form-control-mixins.form-control-tooltip-text;

      &--left {
        @include form-control-mixins.form-control-tooltip-text-left;
      }

      &--left-bottom {
        @include form-control-mixins.form-control-tooltip-text-left-bottom;
      }
    }

    &__tooltip-text::before {
      @include form-control-mixins.form-control-tooltip-text-before;
    }

    &__tooltip-text--left::before {
      @include form-control-mixins.form-control-tooltip-text-left-before;
    }

    &__tooltip-text--left-bottom::before {
      @include form-control-mixins.form-control-tooltip-text-left-bottom-before;
    }

    &__tooltip:hover .jui-control__tooltip-text {
      @include form-control-mixins.tooltip-hover;
    }

    &__icon {
      line-height: 1.1;
      justify-content: center;
      position: absolute;
      align-items: center;
      border-top-left-radius: var(--jui-border-radius);
      border-bottom-left-radius: var(--jui-border-radius);
      border-right: 1px solid var(--jui-input-color-border);
      top: 29px;
      padding: 4px 8px;
    }

    &__error {
      @include form-control-mixins.form-control-error;
    }


    &:focus-within {
      .jui-select__combo {
        @include form-control-mixins.form-control-focused;

        &.jui-select__combo--invalid {
          border-color: var(--jui-danger-color);
          outline-color: var(--jui-danger-color);
          &.jui-select__combo--has-options {
            border-color: var(--jui-input-color-border);
          }
        }

        &.jui-select__combo--has-options {
          outline: unset;
        }
      }

    }


    // SIZE MODIFIERS
    &--lg {
      font-size: var(--jui-input-fs-lg);
      line-height: calc(var(--jui-input-fs-lg) * 1.5) !important;
      & .jui-control__icon {
        top: 34px;
      }

      & .jui-control__reset {
        top: 39px;
      }

      & .jui-control__error {
        font-size: var(--jui-input-fs-lg);
      }

      & .jui-select__combo {
        min-height: 60px;
      }

      & .jui-select__option {
        padding: var(--jds-space-inset);
      }
    }

    &--sm {
      font-size: var(--jui-input-fs-sm);
      line-height: calc(var(--jui-input-fs-sm) * 1.5) !important;
      & .jui-control__icon {
        top: 24px;
      }

      & .jui-control__reset {
        top: 29px;
      }

      & .jui-select__combo {
        min-height: 30px;
        max-height: 30px;
        font-size: var(--jui-input-fs-sm);
      }

      & .jui-select__option {
        padding: var(--jds-space-inset-sm);
      }
    }
  }



  .jui-select {
    display: flex;
    &__container {
      display: flex;
      flex: auto;
      width: 100%;
      border-radius: var(--jui-btn-border-radius);
    }

    &__inline-label {
      background-color: var(--jui-inline-label-color-bg);
      border: 1px solid var(--jui-input-color-border);
      border-right: none;
      font-weight: 500;
      padding: 3px 8px;
      border-top-left-radius: var(--jui-btn-border-radius);
      border-bottom-left-radius: var(--jui-btn-border-radius);
      align-content: center;
    }

    &__combo {
      flex: auto;
      min-height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      @include form-control-mixins.form-control-input-base;

      &--inline-label {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }

      &-input {
        cursor: default;
      }

      &--disabled {
        @include form-control-mixins.form-control-disabled;
      }

      &::placeholder {
        color: var(--jui-input-color-placeholder);
      }

      &--clearable {
        padding-right: 30px;
      }

      &--has-icon {
        padding-left: 50px;
      }

      &--has-focus {
        @include form-control-mixins.form-control-focused;
      }

      &--invalid {
        border-color: var(--jui-danger-color);
        &:focus {
          outline-color: var(--jui-danger-color);
        }
      }

      &-control {
        position: relative;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: var(--jds-space-xxs) var(--jds-space-xs);
        align-self: center;
        flex: 1;
      }

      &-box {
        flex: 1;

        &--single {
          position: absolute;
          left: -1px;
          width: calc(100% - 42px);
        }
        &--readonly {
          display: none;
        }
      }

      &-input {
        border: none;
        background: transparent;
        outline: none;
        width: 100%;
        font-size: inherit;


        &:focus-within,
        &:focus-visible,
        &:focus {
          outline: none;
          border: none;
        }
      }

      &-icons {
        display: flex;
        align-items: center;
        position: relative;
        top: 2px;
        align-self: center;
      }

      &-icon {
        margin: var(--jds-space-inline-xs);
        &:last-of-type {
          margin-right: 0;
        }
      }
    }

    &__single-item {
      user-select: text;

      &--hidden {
        display: none;
      }

      &:focus-visible{
        outline: unset;
      }
      &:focus-within {
        outline: unset;
      }
    }

    &__options {
      background-color: var(--jui-input-color-bg);
      position: relative;

      &--hidden {
        display: none;
      }

      &-container {
        z-index: 1050;
        overflow: hidden;
        overflow-y: auto;
        max-height: 240px;
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
        border: 1px solid #ccc;
        position: absolute;
        width: 100%;
      }
    }

    &__option {
      color: var(--jui-input-color);
      box-sizing: border-box;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: var(--jds-space-inset);

      &:hover {
        background-color: var(--jui-option-color-bg-hover);
      }

      &--focused {
        background-color: var(--jui-option-color-bg-hover);
        color: hotpink;
      }

      &--selected {
        font-weight: 600;
        background-color: var(--jui-option-color-bg-selected);

        &:hover {
          background-color: var(--jui-option-color-bg-selected);
        }
      }
    }

    &__no-items {
      font-weight: 600;
      font-style: italic;
    }

    &__create-new {
      cursor: pointer;
    }

    &__highlighted {
      text-decoration: underline;
      font-weight: 600;
      color: var(--jui-primary-color);
    }
  }
}
